// Clipboard helper with a fallback for non-secure contexts.
//
// `navigator.clipboard.writeText` is only available in secure contexts
// (HTTPS or localhost/127.0.0.1). When the app is served over plain HTTP
// via a LAN IP / hostname, the Clipboard API is undefined or rejects, so
// we fall back to the deprecated-but-universal `document.execCommand('copy')`
// with a hidden textarea (same pattern as ChatPanel.handleCopy).
//
// Returns true if the copy succeeded, false otherwise.

export async function copyToClipboard(text: string): Promise<boolean> {
  // Try the modern async Clipboard API first.
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permission denied or non-secure context -> fall through to legacy.
    }
  }
  // Legacy fallback: hidden textarea + execCommand('copy').
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}